import React from 'react'
import { useTheme } from '@mui/material'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { FileFormatPdfIcon } from 'redesign/components/atoms/Icon'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import Card from 'redesign/components/organisms/Card'
import ContentCard from 'redesign/components/organisms/content-card'
import { DOCUMENT_CARD_IDS } from './constants'
import type { DocumentProps } from './types'
import { useDocument } from './useDocument'

const DocumentCard: React.FC<DocumentProps> = ({ document, openMonthlySheetDialog, hasBorder }) => {
  const { documentLabel, contentData, isNew, displaying, isViewing, displayFileCallback } = useDocument({
    document,
    openMonthlySheetDialog,
  })
  const { subtitle, endText } = contentData
  const { palette } = useTheme()

  if (isViewing) {
    return (
      <Card>
        <LoadingSpinner />
      </Card>
    )
  }

  return (
    <ContentCard
      dataTestId={DOCUMENT_CARD_IDS.document}
      dotDataTestId="status-received"
      header={{
        icon: (
          <FramedIcon
            icon={FileFormatPdfIcon}
            backgroundColor={palette.secondary[200]}
            color={palette.secondary.light}
            isFilled
          />
        ),
        title: documentLabel,
        titleTestId: 'document-title',
        overflowSingleLine: true,
        subtitleOverflowSingleLine: true,
        subtitle,
        subtitleEndText: endText,
        subtitleEndTextTestId: 'document-created-by-mirus',
      }}
      isNew={isNew}
      onClick={() => !displaying && displayFileCallback()}
      hasBorder={hasBorder}
    />
  )
}

export default DocumentCard
